import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="81" height="59" viewBox="0 0 81 59" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter01_d)">
            <path d="M10.0001 48.2998L70.8711 48.2998V44.632L10.0001 44.632V48.2998Z" fill="white"/>
            <path d="M10.0001 41.6694L67.7676 41.6694V38.0017L10.0001 38.0017V41.6694Z" fill="white"/>
            <path opacity="0.35" d="M10.0008 35.0396L52.9561 35.0396V31.3718L10.0008 31.3718V35.0396Z" fill="white"/>
            <path opacity="0.35" d="M10.0714 28.4092L41.7412 28.4092V24.7414L10.0714 24.7414V28.4092Z" fill="white"/>
            <path opacity="0.52"
                  d="M38.3558 12.3977C37.7325 12.3977 37.2273 12.903 37.2273 13.5262C37.2273 14.1495 37.7325 14.6548 38.3558 14.6548C38.9791 14.6548 39.4844 14.1495 39.4844 13.5262C39.4844 12.903 38.9791 12.3977 38.3558 12.3977Z"
                  fill="white"/>
            <path className="path-2"
                  d="M38.3554 10.0701C36.4466 10.0701 34.8992 11.6175 34.8992 13.5262C34.8992 15.435 36.4466 16.9824 38.3554 16.9824C40.2641 16.9824 41.8115 15.435 41.8115 13.5262C41.8115 11.6175 40.2641 10.0701 38.3554 10.0701Z"
                  fill="white"/>
            <path opacity="0.44"
                  d="M14.7269 12.3977C14.1036 12.3977 13.5984 12.903 13.5984 13.5262C13.5984 14.1495 14.1036 14.6548 14.7269 14.6548C15.3502 14.6548 15.8555 14.1495 15.8555 13.5262C15.8555 12.903 15.3502 12.3977 14.7269 12.3977Z"
                  fill="white"/>
            <path opacity="0.41"
                  d="M11.3411 14.3022C11.2705 14.0906 11.2705 13.8085 11.2705 13.5264C11.2705 11.6219 12.8223 10.0702 14.7267 10.0702C15.1499 10.0702 15.5026 10.1407 15.9258 10.2818"
                  fill="white"/>
            <path className="path-1"
                  d="M15.9253 10.2817C17.2655 10.7754 18.2529 12.045 18.2529 13.5262C18.2529 15.4307 16.7012 16.9824 14.7968 16.9824C13.1039 16.9824 11.7638 15.8539 11.4111 14.2316"
                  fill="white"/>
            <path
                d="M26.5765 12.3982C25.9533 12.3982 25.448 12.9034 25.448 13.5267C25.448 14.15 25.9533 14.6553 26.5765 14.6553C27.1998 14.6553 27.7051 14.15 27.7051 13.5267C27.7051 12.9034 27.1998 12.3982 26.5765 12.3982Z"
                fill="white"/>
            <path className="path-3"
                  d="M24.3895 10.7756C24.9538 10.2819 25.7296 9.99976 26.5761 9.99976C28.4805 9.99976 30.0322 11.5515 30.0322 13.4559C30.0322 15.3604 28.4805 16.9121 26.5761 16.9121C26.0118 16.9121 25.4475 16.771 24.9538 16.4889"
                  fill="white"/>
            <path opacity="0.35"
                  d="M24.9531 16.6299C23.8246 16.0656 23.1192 14.8665 23.1192 13.5264C23.1192 12.3978 23.613 11.4104 24.4594 10.7755"
                  fill="white"/>
        </g>
        <defs>
            <filter id="filter01_d" x="0" y="0" width="80.871" height="58.2996" filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset/>
                <feGaussianBlur stdDeviation="5"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.596078 0 0 0 0 1 0 0 0 1 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
        </defs>
    </svg>
)
